export enum FmTabType {
  All = 'all',
  Draft = 'draft',
}

//前端展示状态
export enum FmStatus {
  Draft = 'draft',
  Release = 'approved',
  ReviewFailed = 'approve_fail',
  UnderReview = 'approving',
}

export interface IGetFMDraftListReq {
  cursor: number;
  size: number;
  filter: IGetFMDraftListFilter;
}

export interface IGetFMDraftListResp {
  data_list: IFMDraftItem[];
  has_more: boolean;
  next_cursor: number;
  total_count: number;
}

export interface IGetNpcListForFmReq {
  cursor: number;
  size: number;
}

export interface IGetNpcListForFmResp {
  npc_list: INpcItem[];
  has_more: boolean;
  next_cursor: number;
}

export interface IGetFMCreateConfigReq {}

export interface IGetFMCreateConfigResp {
  scene_list: string[]; //情景主题列表
  tag_list: string[]; //类型标签列表
}

export interface ISubmitFMDraftReq {
  fm_draft: IFMDraftItem;
  audio_url?: string; // 音频文件链接 （title+content 生成)
  audio_duration?: number; // 音频时长,单位 ms
}

export interface ISubmitFMDraftResp {}

export interface IGenerateFMDraftReq {
  scene: GenerateFMDraftScene;
  input: string;
  npc_id: number;
}

export interface IGenerateFMDraftResp {
  fm_draft: IFMDraftItem;
}

export interface IDeleteFMDraftReq {
  fm_draft_id: number;
}

export interface IDeleteFMDraftResp {}

export interface IUpdateFMDraftReq {
  fm_draft: IFMDraftItem;
}

export interface IUpdateFMDraftResp {}

export enum GenerateFMDraftScene {
  AI = 1, // ai生成
  UserImport = 2, // 用户输入
}

export interface IQueryBgmCategoryListReq {}

export interface IQueryBgmCategoryListResp {
  bgm_category_list: IBgmCategory[];
}

export interface IPageQueryBgmListByTagIdReq {
  category_id?: number;
  page?: number;
  size?: number;
}

export interface IPageQueryBgmListByTagIdResp {
  bgm_list: INpcBgmInfo[];
  has_more: boolean;
}

export interface IPreviewToneReq {
  prompt: string;
  with_npc_id: number;
  scene: PreviewToneScene;
}

export interface IPreviewToneResp {
  wav_url: string;
  wav_duration_ms: number;
}

export interface IGetNpcProfileReq {
  user_id?: number; // 用户ID
  npc_id?: number; // NPC ID
}

/**
 * {"npc_info":{"npc_info":{"npc_id":177252204929141,"display_id":"V09gMDKiiy","meta_info":{"name":"墨明","gender":0,"desc":"墨明，一个看似文静的书生，实则有着不为人知的秘密。他出生于一个传统家庭，却偏偏有着一颗探索未知的心。他手中的书本不仅记录着历史的痕迹，还隐藏着通往异世界的门扉。墨明总是在不经意间，用他的幽默和机智化解尴尬，使得周围的人在不知不觉中被他吸引。他那略带讽刺的言辞，总能让人在笑声中深思。在墨明的世界里，没有什么是不可能的，他用他的智慧和勇气，编织着一个个奇妙的故事。","npc_tone":{"Xiaohong":100},"prologue":"（墨明站在古色古香的书架前，转过身来，眼中闪烁着狡黠的光芒）你知道吗？这间藏书室里，每本书都可能藏着通往另一个世界的秘密。但别担心，我会保护你，就像保护这些古老的智慧一样。","default_bgm":"","prologue_wav":"https://filecdn-tts.xingyeai.com/audio-test/chat/tts-mp3-20240903144935-rSlEjDhZ.mp3","prologue_wav_duration":11245,"privacy_setting":1,"npc_tone_name":"角色设定专属音色","hidden_desc":"","npc_source_type":2,"user_define_gender":3,"gender_infer_prob":0,"speed":1,"pitch":0,"video_info":{},"featured_info":{"is_featured":false,"is_ip":false},"long_desc":"","create_timestamp":1725346183195,"group_chat_setting":1,"language":"ZH","simulator_desc":"","standard_desc":"","update_timestamp":1725346183195,"npc_composed_voice_id":"","app_id":300,"previous_owner_id":0,"desc_has_upgrade":false,"feature_switch":{"enable_guest_video_creation":true}},"avatar_info":{"thumbnail_avatar_url":"https://filecdn-images.xingyeai.com/talkie-user-img-test/162864819228783/179368019890289-test.jpeg?x-oss-process=image/resize,w_1024/format,webp","avatar_list":[{"avatar_id":179375184621643,"avatar_img_url":"https://filecdn-images.xingyeai.com/image_inference_output/nebula/prod/img/2024-09-03/18bbe1b1-adb9-4220-bf1d-d3e67a6bc9e4.jpeg?x-oss-process=image/resize,w_1024/format,webp","avatar_tag":1,"img_desc":"","avatar_head_position":{"top":195,"bottom":633,"left":292,"right":730},"avatar_depth_img_url":"","style_name":"写真","lora_id":"","extra":"","keywords":["1girl","sitting","solo","indoors","pocket","denim jacket","jacket","realistic","1boy","bracelet","closed mouth","denim","looking to the side","pants","short hair","black eyes","black shirt","jeans","long sleeves","black jacket","black pants","brown eyes","male focus","leather jacket","lips","leather","shirt","black hair","jewelry"],"new_extra_xl_model":"{\"config_name\": \"240716-SDXL-v2.1-nebula-Avatar-StyleGroup\", \"model_name\": \"nero-gen2-ft-sdxlFix-8n-20230825-s15f6-hq240605-rl-tags-mjft-v6-512K\", \"prompt\": \"(best quality, rich details, photo realistic :1.0)\", \"negative_prompt\": \"NSFW, pussy, nipple, head out of frame, lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username, blurry, wide shot, (simple background:1.5)\", \"seed\": 4004104459, \"stage1_solve\": {\"name\": \"Eulera\", \"algorithm_type\": null}, \"stage2_solve\": {\"name\": \"Eulera\", \"algorithm_type\": null}, \"first_stage_height\": 1376, \"first_stage_width\": 760, \"first_stage_steps\": 40, \"second_stage_height\": 1376, \"second_stage_width\": 760, \"second_stage_steps\": 20, \"first_stage_denoise\": 0.8, \"second_stage_denoise\": 0.5, \"cfg_scale\": 7.5, \"parsed_prompts\": {\"base_user_input\": {\"keys\": [\"prompt_kw.description\"], \"weight\": 1, \"prompt\": \"\", \"real_weight\": 1.0}, \"style_prepend_prompt\": {\"keys\": [\"user_ref_dict.base_avatar_style.0.prompt_prepend\"], \"weight\": 1, \"prompt\": \"best quality, rich details, photo realistic\", \"real_weight\": 1.0}}, \"parsed_ref_dict\": {\"base_avatar_face\": [], \"base_avatar_style\": [{\"category\": \"style\", \"format\": \"image\", \"key\": \"240229_official_portrait/portrait_1.png\", \"prompt_prepend\": \"best quality, rich details, photo realistic\", \"source\": \"juicefs\", \"weight\": [\"uniform\", 0.8, 1], \"real_weight\": 0.8088124394416809}]}, \"nsfw_info\": {\"flag\": false, \"score\": -0.042, \"minor\": -0.049, \"porn_feed_pass\": true, \"minor_block_pass\": true, \"asia_face_tag\": false}}","create_time":1725346183203,"new_extra":"{\"config_name\": \"240716-SDXL-v2.1-nebula-Avatar-StyleGroup\", \"model_name\": \"nero-gen2-ft-sdxlFix-8n-20230825-s15f6-hq240605-rl-tags-mjft-v6-512K\", \"prompt\": \"(best quality, rich details, photo realistic :1.0)\", \"negative_prompt\": \"NSFW, pussy, nipple, head out of frame, lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username, blurry, wide shot, (simple background:1.5)\", \"seed\": 4004104459, \"stage1_solve\": {\"name\": \"Eulera\", \"algorithm_type\": null}, \"stage2_solve\": {\"name\": \"Eulera\", \"algorithm_type\": null}, \"first_stage_height\": 1376, \"first_stage_width\": 760, \"first_stage_steps\": 40, \"second_stage_height\": 1376, \"second_stage_width\": 760, \"second_stage_steps\": 20, \"first_stage_denoise\": 0.8, \"second_stage_denoise\": 0.5, \"cfg_scale\": 7.5, \"parsed_prompts\": {\"base_user_input\": {\"keys\": [\"prompt_kw.description\"], \"weight\": 1, \"prompt\": \"\", \"real_weight\": 1.0}, \"style_prepend_prompt\": {\"keys\": [\"user_ref_dict.base_avatar_style.0.prompt_prepend\"], \"weight\": 1, \"prompt\": \"best quality, rich details, photo realistic\", \"real_weight\": 1.0}}, \"parsed_ref_dict\": {\"base_avatar_face\": [], \"base_avatar_style\": [{\"category\": \"style\", \"format\": \"image\", \"key\": \"240229_official_portrait/portrait_1.png\", \"prompt_prepend\": \"best quality, rich details, photo realistic\", \"source\": \"juicefs\", \"weight\": [\"uniform\", 0.8, 1], \"real_weight\": 0.8088124394416809}]}, \"nsfw_info\": {\"flag\": false, \"score\": -0.042, \"minor\": -0.049, \"porn_feed_pass\": true, \"minor_block_pass\": true, \"asia_face_tag\": false}}","background_bottom_offset":0,"caption":"","small_thumbnail_url":"https://filecdn-images.xingyeai.com/image_inference_output/nebula/prod/img/2024-09-03/18bbe1b1-adb9-4220-bf1d-d3e67a6bc9e4.jpeg?x-oss-process=image/resize,w_1024/format,webp","dominate_color":"#383430","flux_ai_writer":""},{"avatar_id":179375184621645,"avatar_img_url":"https://filecdn-images.xingyeai.com/talkie-user-img-test/162864819228783/179368019890289-test.jpeg?x-oss-process=image/resize,w_1024/format,webp","avatar_tag":2,"img_desc":"","avatar_head_position":{"top":95,"bottom":733,"left":192,"right":830},"avatar_depth_img_url":"","style_name":"","lora_id":"","extra":"","new_extra_xl_model":"","create_time":1725346183203,"new_extra":"","background_bottom_offset":0,"caption":"","small_thumbnail_url":"https://filecdn-images.xingyeai.com/talkie-user-img-test/162864819228783/179368019890289-test.jpeg?x-oss-process=image/resize,w_1024/format,webp","dominate_color":"","flux_ai_writer":""},{"avatar_id":179375184621644,"avatar_img_url":"https://filecdn-images.xingyeai.com/talkie-user-img-test/162864819228783/179368019890290-test.jpeg?x-oss-process=image/resize,w_1024/format,webp","avatar_tag":4,"img_desc":"","avatar_head_position":{"top":195,"bottom":633,"left":292,"right":730},"avatar_depth_img_url":"","style_name":"写真","lora_id":"","extra":"","new_extra_xl_model":"","create_time":1725346183203,"new_extra":"","background_bottom_offset":0,"caption":"","small_thumbnail_url":"https://filecdn-images.xingyeai.com/talkie-user-img-test/162864819228783/179368019890290-test.jpeg?x-oss-process=image/resize,w_1024/format,webp","dominate_color":"","flux_ai_writer":""},{"avatar_id":179375184621642,"avatar_img_url":"","avatar_tag":5,"img_desc":"","avatar_depth_img_url":"","style_name":"","lora_id":"","extra":"","new_extra_xl_model":"","create_time":1725346183203,"new_extra":"","background_bottom_offset":0,"caption":"","small_thumbnail_url":"","dominate_color":"","flux_ai_writer":""}]},"author":{"user_id":162864819228783,"user_name":"小星星lzHIuskA","user_avatar_url":"https://filecdn-images.xingyeai.com/default/user_default.png?x-oss-process=image/resize,w_512/format,webp"},"edit_version":0,"im_info":{"im_account":"n___177252204929141"},"moderation_status":{"final_decision":0,"next_version_status":1,"user_can_chat":true,"user_can_share":false},"background_img":{"img_url":"https://filecdn-images.xingyeai.com/image_inference_output/nebula/prod/img/2024-09-03/18bbe1b1-adb9-4220-bf1d-d3e67a6bc9e4.jpeg?x-oss-process=image/resize,w_1024/format,webp","depth_img_url":"","img_type":2,"dominate_color":"#383430","npc_default_color":"#383430","small_thumbnail_img_url":"https://filecdn-images.xingyeai.com/image_inference_output/nebula/prod/img/2024-09-03/18bbe1b1-adb9-4220-bf1d-d3e67a6bc9e4.jpeg?x-oss-process=image/resize,w_1024/format,webp"},"extra_info":{"has_direct_card":false,"created_at":1725346183195,"dismiss_story":false,"dismiss_detail":false,"dismiss_report":false,"dismiss_feedback_msg":false,"dismiss_retalk_card":false,"seo_source":0,"dismiss_tier":false,"dismiss_author_card":false,"enable_prologue_recommend":false,"has_bottom_bar":false,"disable_rephrase":false,"manual_create_reson":0},"is_ai_clone":false,"chat_model":"剧情演绎","npc_agent_type":1,"npc_phase_count":1,"moderation_detail":{}},"follow_status":0,"statistic_info":{"followers_count":0,"linkers_count":0,"co_creator_count":0,"moment_count":0,"light_score":61},"has_chatted":false,"title_count":0,"fm_count":0},"tier_score":{"score":0,"max_score":2000,"next_reward":"差10星缘 每日额外1分钟免费通话","next_reward_score":10,"has_available_card":false},"comment_entrance":{"has_comment_entrance":true,"texts":[{"text":"抢首评","highlight":false}],"track_params":"{\"comments_people_count\":0}"},"long_article_count":0,"base_resp":{"status_code":0,"status_msg":"success"}}
 */
export interface IGetNpcProfileResp {
  npc_info: {
    npc_info: {
      npc_id: number;
      display_id: string;
      meta_info: {
        name: string;
        gender: number;
        desc: string;
        npc_tone: Record<string, number>;
        prologue: string;
        default_bgm: string;
        prologue_wav: string;
        prologue_wav_duration: number;
        privacy_setting: number;
        npc_tone_name: string;
        hidden_desc: string;
        npc_source_type: number;
        user_define_gender: number;
        gender_infer_prob: number;
        speed: number;
        pitch: number;
        video_info: Record<string, any>;
        featured_info: {
          is_featured: boolean;
          is_ip: boolean;
        };
        long_desc: string;
        create_timestamp: number;
        group_chat_setting: number;
        language: string;
        simulator_desc: string;
        standard_desc: string;
        update_timestamp: number;
        npc_composed_voice_id: string;
        app_id: number;
        previous_owner_id: number;
        desc_has_upgrade: boolean;
        feature_switch: {
          enable_guest_video_creation: boolean;
        };
      };
      avatar_info: {
        thumbnail_avatar_url: string;
        avatar_list: {
          avatar_id: number;
          avatar_img_url: string;
          avatar_tag: number;
          img_desc: string;
          avatar_head_position: {
            top: number;
            bottom: number;
            left: number;
            right: number;
          };
          avatar_depth_img_url: string;
          style_name: string;
          lora_id: string;
          extra: string;
          keywords?: string[];
          new_extra_xl_model: string;
          create_time: number;
          new_extra: string;
          background_bottom_offset: number;
          caption: string;
          small_thumbnail_url: string;
          dominate_color: string;
          flux_ai_writer: string;
        }[];
      };
      author: {
        user_id: number;
        user_name: string;
        user_avatar_url: string;
      };
      edit_version: number;
      im_info: {
        im_account: string;
      };
      moderation_status: {
        final_decision: number;
        next_version_status: number;
        user_can_chat: boolean;
        user_can_share: boolean;
      };
      background_img: {
        img_url: string;
        depth_img_url: string;
        img_type: number;
        dominate_color: string;
        npc_default_color: string;
        small_thumbnail_img_url: string;
      };
      extra_info: {
        has_direct_card: boolean;
        created_at: number;
        dismiss_story: boolean;
        dismiss_detail: boolean;
        dismiss_report: boolean;
        dismiss_feedback_msg: boolean;
        dismiss_retalk_card: boolean;
        seo_source: number;
        dismiss_tier: boolean;
        dismiss_author_card: boolean;
        enable_prologue_recommend: boolean;
        has_bottom_bar: boolean;
        disable_rephrase: boolean;
        manual_create_reson: number;
      };
      is_ai_clone: boolean;
      chat_model: string;
      npc_agent_type: number;
      npc_phase_count: number;
      moderation_detail: Record<string, any>;
    };
    follow_status: number;
    statistic_info: {
      followers_count: number;
      linkers_count: number;
      co_creator_count: number;
      moment_count: number;
      light_score: number;
    };
    has_chatted: boolean;
    title_count: number;
    fm_count: number;
  };
  tier_score: {
    score: number;
    max_score: number;
    next_reward: string;
    next_reward_score: number;
    has_available_card: boolean;
  };
  comment_entrance: {
    has_comment_entrance: boolean;
    texts: Record<string, any>[];
    track_params: string;
  };
  long_article_count: number;
  base_resp: {
    status_code: number;
    status_msg: string;
  };
}

export enum PreviewToneScene {
  Default = 0, //  默认场景
  FM = 1, // fm场景会在text处理上有些diff操作
}

export interface IBgmCategory {
  category_id: number;
  category_name: string;
}

export interface IGetFMDraftListFilter {
  only_not_submit: boolean;
}

export interface IFMDraftItem {
  id: number;
  fm_id: number;
  bg_image?: string;
  title?: string;
  script_list: IFMDraftScript[];
  last_delay: IFMDraftScript;
  bgm_id?: number;
  is_submitted: boolean;
  npc_id: number;
  status: IModerationDecision;
  bgm_info?: INpcBgmInfo;
  tag_list?: string[]; // 作品类型
  _dirty?: boolean;
  _concatAudioUrl?: string;
  _isMixing?: boolean;
  _isSubmitting?: boolean;
  npc_name?: string;
  bgm_volume?: number;
}

export enum IModerationDecision {
  //审核中
  UnderReview = 0,
  //审核通过
  ReviewPassed = 100,
  //审核不通过
  ReviewFailed = 300,
}

export interface IFMDraftScript {
  _id: string; //前端临时id
  content: string;
  wait_time_ms: number;
  audio_url: string;
  audio_duration: number;
  _changed?: boolean;
  _isGenerating?: boolean;
}

export interface INpcBgmInfo {
  bgm_id: number;
  bgm_url: string;
  bgm_name: string;
  bgm_tag_list: string[];
  bgm_category: IBgmCategory;
  use_count: number;
}

export interface INpcItem {
  npc_id: number;
  name: string;
  npc_bg_image: IImage;
  avatar: IImage;
  desc: string;
  statistic_info: IStatisticInfo;
  imAccount: string;
}

export interface IImage {
  url: string;
  width?: number;
  height?: number;
  dominate_color?: string;
}

export interface IStatisticInfo {
  linkers_count: number;
}

export interface IGetFmDraftReq {
  fm_draft_id: number;
}

export interface IGetFmDraftResp {
  fm_draft: IFMDraftItem;
}

export enum ModerationScene {
  TemplateTextInput = 1,
  FMText = 2, // fm的文本
}

export interface IModerationTextReq {
  text: string;
  scene: ModerationScene;
}

export interface IModerationTextResp {
  text_safe: boolean;
}

export interface IDeleteFmDraftReq {
  fm_draft_id: number;
}

export interface IDeleteFmDraftResp {}
